"use strict";

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decideModel = exports.measureAndDecideExecutionApproach = void 0;

var loader_js_1 = require("./loader.js");

var support_js_1 = require("./support.js");

var DEFAULT_EXECUTION_QUANTA = 3;
var SIMD_SCORE_FIXED_POINT = 2.50;
var WASM_SCORE_FIXED_POINT = 2.63;
var SINGLE_INLINE_SCORE_MULTIPLIER = 0.6;
var QUALITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER = 0.65;
var INTERACTIVITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER = 0.5;
var WORKER_SCORE_MULTIPLIER = 0.7;
var PERFORMANCE_THRESHOLDS = {
  wasm: {
    noSupport: 0.07,
    inline: {
      c100: 1,
      c50: 0.36,
      c20: 0.16,
      c10: 0.07
    },
    worker: {
      c100: 0.5,
      c50: 0.18,
      c20: 0.08,
      c10: 0.06
    }
  },
  simd: {
    noSupport: 0.10,
    inline: {
      c100: 1,
      c50: 0.43,
      c20: 0.3,
      c10: 0.2
    },
    worker: {
      c100: 0.5,
      c50: 0.21,
      c20: 0.15,
      c10: 0.10
    }
  }
};

var Estimator = /*#__PURE__*/function () {
  function Estimator(fetchConfig, logger) {
    _classCallCheck(this, Estimator);

    this.fetchConfig = fetchConfig;
    this.logger = logger;
    var workerURL = "".concat(fetchConfig.paths.workers, "estimator-v1.js");
    this.fetchBehavior = {
      headers: fetchConfig.headers,
      escapedQueryString: fetchConfig.escapedQueryString
    };
    this.worker = loader_js_1.loadWorker(workerURL, 'VoiceFocusEstimator', this.fetchBehavior, logger);
  }

  _createClass(Estimator, [{
    key: "roundtrip",
    value: function roundtrip(toSend, receive, expectedKey) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        _this.worker.then(function (worker) {
          var _listener;

          _listener = function listener(event) {
            var _event$data = event.data,
                message = _event$data.message,
                key = _event$data.key;

            if (message === receive && key === expectedKey) {
              worker.removeEventListener('message', _listener);
              resolve(event.data);
            }
          };

          worker.addEventListener('message', _listener);
          worker.postMessage(toSend);
        }).catch(function (e) {
          var _a;

          (_a = _this.logger) === null || _a === void 0 ? void 0 : _a.error('Failed to load worker.', e);
          reject(e);
        });
      });
    }
  }, {
    key: "supportsSIMD",
    value: function supportsSIMD(url) {
      var key = 'simd';
      var path = url || "".concat(this.fetchConfig.paths.wasm, "simd-v1.wasm");
      var toSend = {
        message: 'supports-simd',
        fetchBehavior: this.fetchBehavior,
        path: path,
        key: key
      };
      return this.roundtrip(toSend, 'simd-support', key).then(function (data) {
        return data.supports;
      });
    }
  }, {
    key: "measure",
    value: function measure(simd, budget) {
      var benchWASM = "".concat(this.fetchConfig.paths.wasm, "bench-v1.wasm");
      var benchSIMD = "".concat(this.fetchConfig.paths.wasm, "bench-v1_simd.wasm");
      var path = simd ? benchSIMD : benchWASM;
      var key = "bench:".concat(simd);
      var toSend = {
        message: 'measure',
        fetchBehavior: this.fetchBehavior,
        budget: budget,
        path: path,
        key: key
      };
      return this.roundtrip(toSend, 'measurement', key).then(function (data) {
        if (data.measurement) {
          return data.measurement;
        }

        throw new Error('Failed to measure.');
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var _this2 = this;

      this.worker.then(function (worker) {
        var _a;

        (_a = _this2.logger) === null || _a === void 0 ? void 0 : _a.debug('Stopping estimator worker.');
        worker.terminate();
      }).catch(function (e) {});
    }
  }]);

  return Estimator;
}();

var inlineScoreMultiplier = function inlineScoreMultiplier(executionQuanta, usagePreference) {
  if (executionQuanta === 1) {
    return SINGLE_INLINE_SCORE_MULTIPLIER;
  }

  if (usagePreference === 'quality') {
    return QUALITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER * executionQuanta;
  }

  return INTERACTIVITY_MULTIPLE_QUANTA_SCORE_MULTIPLIER * executionQuanta;
};

var decideExecutionApproach = function decideExecutionApproach(_ref) {
  var supportsSIMD = _ref.supportsSIMD,
      supportsSAB = _ref.supportsSAB,
      duration = _ref.duration,
      _ref$executionPrefere = _ref.executionPreference,
      executionPreference = _ref$executionPrefere === void 0 ? 'auto' : _ref$executionPrefere,
      simdPreference = _ref.simdPreference,
      _ref$variantPreferenc = _ref.variantPreference,
      variantPreference = _ref$variantPreferenc === void 0 ? 'auto' : _ref$variantPreferenc,
      _ref$namePreference = _ref.namePreference,
      namePreference = _ref$namePreference === void 0 ? 'default' : _ref$namePreference,
      usagePreference = _ref.usagePreference,
      _ref$executionQuantaP = _ref.executionQuantaPreference,
      executionQuantaPreference = _ref$executionQuantaP === void 0 ? DEFAULT_EXECUTION_QUANTA : _ref$executionQuantaP;
  var allThresholds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PERFORMANCE_THRESHOLDS;
  var logger = arguments.length > 2 ? arguments[2] : undefined;
  var forceSIMD = simdPreference === 'force';
  var useSIMD = forceSIMD || simdPreference !== 'disable' && supportsSIMD;
  var checkScores = duration !== -1;
  var baseScore = checkScores ? (useSIMD ? SIMD_SCORE_FIXED_POINT : WASM_SCORE_FIXED_POINT) / duration : 0;
  var thresholds = useSIMD ? allThresholds.simd : allThresholds.wasm;
  var inlineScore = checkScores ? inlineScoreMultiplier(executionQuantaPreference, usagePreference) * baseScore : 0;
  var workerScore = checkScores ? WORKER_SCORE_MULTIPLIER * baseScore : 0;
  var name = namePreference;

  var unsupported = function unsupported(reason) {
    return {
      supported: false,
      reason: reason
    };
  };

  if (checkScores) {
    if (baseScore < thresholds.noSupport) {
      return unsupported("Performance score ".concat(baseScore, " worse than threshold ").concat(thresholds.noSupport, "."));
    }
  } else {
    if (executionPreference === 'auto' || variantPreference === 'auto') {
      return unsupported("Missing explicit execution (".concat(executionPreference, ") or variant (").concat(variantPreference, ") preference, but no scoring performed."));
    }
  }

  logger === null || logger === void 0 ? void 0 : logger.debug("Bench duration ".concat(duration, " yields inline score ").concat(inlineScore, " and worker score ").concat(workerScore, "."));

  var succeed = function succeed(processor, executionApproach, variant) {
    return {
      supported: true,
      useSIMD: useSIMD,
      processor: processor,
      executionApproach: executionApproach,
      variant: variant,
      executionQuanta: executionApproach === 'inline' ? executionQuantaPreference : undefined,
      name: name
    };
  };

  var resolveVariant = function resolveVariant(score, variant, lookup) {
    if (variant !== 'auto') {
      if (!checkScores || score > lookup[variant]) {
        return variant;
      }

      return 'failed';
    }

    if (score > lookup.c100) {
      return 'c100';
    }

    if (score > lookup.c50) {
      return 'c50';
    }

    if (score > lookup.c20) {
      return 'c20';
    }

    if (score > lookup.c10) {
      return 'c10';
    }

    return 'failed';
  };

  var reducePreference = function reducePreference(preference) {
    switch (preference || 'auto') {
      case 'auto':
        {
          var inlineOption = reducePreference('inline');
          var workerOption = reducePreference('worker');
          logger === null || logger === void 0 ? void 0 : logger.debug("Reducing auto preference: ".concat(JSON.stringify(inlineOption), " vs ").concat(JSON.stringify(workerOption)));

          if (inlineOption.supported === false) {
            return workerOption;
          }

          if (workerOption.supported === false) {
            return workerOption;
          }

          if (inlineOption.variant === workerOption.variant || inlineOption.variant === 'c50') {
            return inlineOption;
          }

          return workerOption;
        }

      case 'worker':
        {
          if (support_js_1.supportsSharedArrayBuffer(globalThis, window, logger)) {
            return reducePreference('worker-sab');
          }

          return reducePreference('worker-postMessage');
        }

      case 'inline':
        {
          var variant = resolveVariant(inlineScore, variantPreference, thresholds.inline);

          if (variant === 'failed') {
            return unsupported("Performance score ".concat(inlineScore, " not sufficient for inline use with variant preference ").concat(variantPreference, "."));
          }

          ;
          return succeed('voicefocus-inline-processor', 'inline', variant);
        }

      case 'worker-sab':
        {
          if (!supportsSAB) {
            var reason = 'Requested worker-sab but no SharedArrayBuffer support.';
            logger === null || logger === void 0 ? void 0 : logger.warn(reason);
            return {
              supported: false,
              reason: reason
            };
          }

          var _variant = resolveVariant(workerScore, variantPreference, thresholds.worker);

          if (_variant === 'failed') {
            return unsupported("Performance score ".concat(workerScore, " not sufficient for worker use with variant preference ").concat(variantPreference, "."));
          }

          ;
          return succeed('voicefocus-worker-sab-processor', 'worker-sab', _variant);
        }

      case 'worker-postMessage':
        {
          var _variant2 = resolveVariant(workerScore, variantPreference, thresholds.worker);

          if (_variant2 === 'failed') {
            return unsupported("Performance score ".concat(workerScore, " not sufficient for worker use."));
          }

          ;

          if (name === 'ns_es') {
            var _reason = 'Requested echo suppression but postMessage executor does not support it.';
            logger === null || logger === void 0 ? void 0 : logger.warn(_reason);
            return {
              supported: false,
              reason: _reason
            };
          }

          ;
          return succeed('voicefocus-worker-postMessage-processor', 'worker-postMessage', _variant2);
        }
    }
  };

  return reducePreference(executionPreference);
};

var featureCheck = function featureCheck(forceSIMD, fetchConfig, logger, estimator) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var supports, cleanup, e, useSIMD;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            supports = {
              supportsSIMD: forceSIMD,
              supportsSAB: support_js_1.supportsSharedArrayBuffer(globalThis, window, logger),
              duration: -1
            };

            if (!forceSIMD) {
              _context.next = 4;
              break;
            }

            logger === null || logger === void 0 ? void 0 : logger.info('Supports SIMD: true (force)');
            return _context.abrupt("return", supports);

          case 4:
            cleanup = !estimator;
            e = estimator || new Estimator(fetchConfig, logger);
            _context.prev = 6;
            _context.t0 = !support_js_1.isOldChrome(window, logger);

            if (!_context.t0) {
              _context.next = 12;
              break;
            }

            _context.next = 11;
            return e.supportsSIMD();

          case 11:
            _context.t0 = _context.sent;

          case 12:
            useSIMD = _context.t0;
            logger === null || logger === void 0 ? void 0 : logger.info("Supports SIMD: ".concat(useSIMD, " (force: ").concat(forceSIMD, ")"));
            supports.supportsSIMD = useSIMD;
            return _context.abrupt("return", supports);

          case 16:
            _context.prev = 16;

            if (cleanup) {
              e.stop();
            }

            return _context.finish(16);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6,, 16, 19]]);
  }));
};

var estimateAndFeatureCheck = function estimateAndFeatureCheck(forceSIMD, fetchConfig, estimatorBudget, logger) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var estimator, supports;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            estimator = new Estimator(fetchConfig, logger);
            _context2.prev = 1;
            _context2.next = 4;
            return featureCheck(forceSIMD, fetchConfig, logger, estimator);

          case 4:
            supports = _context2.sent;

            if (!supports.supportsSIMD) {
              _context2.next = 18;
              break;
            }

            _context2.prev = 6;
            _context2.next = 9;
            return estimator.measure(true, estimatorBudget);

          case 9:
            supports.duration = _context2.sent;
            logger === null || logger === void 0 ? void 0 : logger.info('SIMD timing:', supports.duration);
            return _context2.abrupt("return", supports);

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](6);
            logger === null || logger === void 0 ? void 0 : logger.warn('Failed SIMD estimation; falling back to non-SIMD.');
            supports.supportsSIMD = false;

          case 18:
            _context2.next = 20;
            return estimator.measure(false, estimatorBudget);

          case 20:
            supports.duration = _context2.sent;
            logger === null || logger === void 0 ? void 0 : logger.info('No-SIMD timing:', supports.duration);
            return _context2.abrupt("return", supports);

          case 25:
            _context2.prev = 25;
            _context2.t1 = _context2["catch"](1);
            logger === null || logger === void 0 ? void 0 : logger.error('Could not feature check.', _context2.t1);
            throw _context2.t1;

          case 29:
            _context2.prev = 29;
            estimator.stop();
            return _context2.finish(29);

          case 32:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[1, 25, 29, 32], [6, 14]]);
  }));
};

var measureAndDecideExecutionApproach = function measureAndDecideExecutionApproach(spec, fetchConfig, logger) {
  var thresholds = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : PERFORMANCE_THRESHOLDS;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var executionPreference, usagePreference, variantPreference, namePreference, simdPreference, estimatorBudget, executionQuantaPreference, forceSIMD, knownModel, knownExecution, supports;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            executionPreference = spec.executionPreference;
            usagePreference = spec.usagePreference, variantPreference = spec.variantPreference, namePreference = spec.namePreference, simdPreference = spec.simdPreference, estimatorBudget = spec.estimatorBudget, executionQuantaPreference = spec.executionQuantaPreference;

            if (usagePreference === 'interactivity' && executionPreference !== 'inline') {
              logger === null || logger === void 0 ? void 0 : logger.debug("Overriding execution preference ".concat(executionPreference, " to reflect interactivity preference."));
              executionPreference = 'inline';
            }

            forceSIMD = simdPreference === 'force';
            knownModel = variantPreference !== 'auto';
            knownExecution = executionPreference !== 'auto';
            _context3.prev = 6;

            if (!(knownModel && knownExecution)) {
              _context3.next = 13;
              break;
            }

            _context3.next = 10;
            return featureCheck(forceSIMD, fetchConfig, logger);

          case 10:
            supports = _context3.sent;
            _context3.next = 16;
            break;

          case 13:
            _context3.next = 15;
            return estimateAndFeatureCheck(forceSIMD, fetchConfig, estimatorBudget, logger);

          case 15:
            supports = _context3.sent;

          case 16:
            _context3.next = 22;
            break;

          case 18:
            _context3.prev = 18;
            _context3.t0 = _context3["catch"](6);
            logger === null || logger === void 0 ? void 0 : logger.error('Could not load estimator.', _context3.t0);
            throw new Error('Could not load Voice Focus estimator.');

          case 22:
            return _context3.abrupt("return", decideExecutionApproach(Object.assign(Object.assign({}, supports), {
              simdPreference: simdPreference,
              executionPreference: executionPreference,
              variantPreference: variantPreference,
              namePreference: namePreference,
              usagePreference: usagePreference,
              executionQuantaPreference: executionQuantaPreference
            }), thresholds, logger));

          case 23:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[6, 18]]);
  }));
};

exports.measureAndDecideExecutionApproach = measureAndDecideExecutionApproach;

var decideModel = function decideModel(_ref2) {
  var category = _ref2.category,
      name = _ref2.name,
      variant = _ref2.variant,
      simd = _ref2.simd,
      url = _ref2.url;
  return "".concat(category, "-").concat(name, "-").concat(variant, "-v1").concat(simd ? '_simd' : '');
};

exports.decideModel = decideModel;